const HideShow = (() => {
  const toggles = Array.from(document.querySelectorAll('[data-hide-show]'));

  const show = (toggle, el) => {
    toggle.setAttribute('aria-expanded', true);
    el.setAttribute('aria-hidden', false);
  };

  const hide = (toggle, el) => {
    toggle.setAttribute('aria-expanded', false);
    el.setAttribute('aria-hidden', true);
  };

  return {
    init: () => {
      if (toggles.length > 0) { 
        toggles.forEach(toggle => {
          let el = document.getElementById(toggle.getAttribute('aria-controls'));

          toggle.onclick = () => {
            let expanded = toggle.getAttribute('aria-expanded');
            if (expanded == "true") {
              hide(toggle, el)
            } else {
              show(toggle, el);
            }
          };
        });
      }
    }
  }

})();

export default HideShow;


// WEBPACK FOOTER //
// ./src/js/components/hide-show.js